import { fetchArticleCategories as fetchArticleCategoriesApi, fetchHome } from '@/api/community'

const actions = {
  SET_ARTICLE_CATEGORIES: function ({ locale, categories }) {
    this.articleCategories[locale] = categories
  },

  SET_HOME_CONTENT: function (val) {
    this.homeContent = val
  },

  SET_ACTIVE_CONTENT: function ({ type, id, slug }) {
    this.activeContent = { type, id, slug }
  },

  // #region Loaders
  loadHomeContent: async function ({ locale, countryId }) {
    if (this.homeContent.length === 0) {
      await this.fetchHomeContent({ locale, countryId })
    }
  },

  loadArticleCategories: async function ({ locale, countryId }) {
    if (this.getArticleCategories(locale).length === 0) {
      await this.fetchArticleCategories({ locale, countryId })
    }
  },

  // #endregion

  // #region Fetchers
  fetchHomeContent: async function ({ locale, countryId }) {
    const content = await fetchHome(locale, countryId)
    this.SET_HOME_CONTENT(content)
  },
  fetchArticleCategories: async function ({ locale, countryId }) {
    const categories = await fetchArticleCategoriesApi(locale, countryId)
    this.SET_ARTICLE_CATEGORIES({ locale, categories })
  },
  // #endregion
  // #region Active Content
  setActiveContent: function ({ type, id = '', slug = '' }) {
    this.SET_ACTIVE_CONTENT({ type, id, slug })
  }
}
// #endregion

export default actions
